import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function Testimonials() {
  const chats = [{
    name: 'Lucía',
    age: 28,
    city: 'Buenos Aires',
    avatar: 'L',
    color: 'from-pink-400 to-rose-400',
    messages: [{
      text: 'Chicas, les cuento que empecé con Energía Real hace una semana',
      time: '10:23',
      isOwn: false
    }, {
      text: 'Pensé que me faltaba disciplina, pero era agotamiento mental 😮',
      time: '10:24',
      isOwn: false
    }, {
      text: 'En serio me sentí más liviana en solo 7 días',
      time: '10:24',
      isOwn: false
    }]
  }, {
    name: 'Martina',
    age: 34,
    city: 'Córdoba',
    avatar: 'M',
    color: 'from-fuchsia-400 to-purple-400',
    messages: [{
      text: 'A mí me pasó igual!',
      time: '10:26',
      isOwn: false
    }, {
      text: 'Este método no te exige, te ordena por dentro',
      time: '10:26',
      isOwn: false
    }, {
      text: 'Por fin siento alivio de verdad 💜',
      time: '10:27',
      isOwn: false
    }]
  }, {
    name: 'Sofía',
    age: 31,
    city: 'Rosario',
    avatar: 'S',
    color: 'from-purple-400 to-indigo-400',
    messages: [{
      text: 'Lo mejor fue dejar de sentirme culpable por descansar',
      time: '10:30',
      isOwn: false
    }, {
      text: 'Cambió mi forma de vivir completamente',
      time: '10:30',
      isOwn: false
    }, {
      text: 'Ya no me exijo tanto ✨',
      time: '10:31',
      isOwn: false
    }]
  }, {
    name: 'Valentina',
    age: 29,
    city: 'Mendoza',
    avatar: 'V',
    color: 'from-pink-400 to-fuchsia-400',
    messages: [{
      text: 'No sabía que podía sentirme así de liviana siendo adulta',
      time: '10:35',
      isOwn: false
    }, {
      text: 'Es como si me hubieran quitado un peso invisible',
      time: '10:36',
      isOwn: false
    }]
  }, {
    name: 'Camila',
    age: 36,
    city: 'La Plata',
    avatar: 'C',
    color: 'from-rose-400 to-pink-400',
    messages: [{
      text: 'Recuperé energía sin agregar nada a mi vida',
      time: '10:40',
      isOwn: false
    }, {
      text: 'Solo soltando lo que no servía 🙌',
      time: '10:40',
      isOwn: false
    }, {
      text: 'Súper recomendado chicas!',
      time: '10:41',
      isOwn: false
    }]
  }];
  return <Section background="light-purple" data-id="element-258">
      <div className="text-center mb-12" data-id="element-259">
        <h2 className="text-4xl md:text-5xl font-black text-slate-900 mb-4" data-id="element-260">
          Lo que dicen{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-600 to-pink-600" data-id="element-261">
            otras mujeres
          </span>
        </h2>
        <p className="text-slate-600 text-lg" data-id="element-262">
          Conversaciones reales de nuestra comunidad
        </p>
      </div>

      <div className="max-w-4xl mx-auto space-y-8" data-id="element-263">
        {chats.map((chat, chatIndex) => <motion.div key={chatIndex} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: chatIndex * 0.1
      }} viewport={{
        once: true
      }} className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 border-2 border-purple-100 shadow-xl" data-id="element-264">
            {/* Chat Header */}
            <div className="flex items-center gap-3 mb-6 pb-4 border-b border-purple-100" data-id="element-265">
              <div className={`w-12 h-12 rounded-full bg-gradient-to-br ${chat.color} flex items-center justify-center text-white font-bold text-lg shadow-lg`} data-id="element-266">
                {chat.avatar}
              </div>
              <div data-id="element-267">
                <p className="font-bold text-slate-900" data-id="element-268">
                  {chat.name}, {chat.age}
                </p>
                <p className="text-sm text-slate-600" data-id="element-269">{chat.city}</p>
              </div>
              <div className="ml-auto" data-id="element-270">
                <div className="flex items-center gap-1 text-green-600 text-xs" data-id="element-271">
                  <Check className="w-3 h-3" data-id="element-272" />
                  <Check className="w-3 h-3 -ml-2" data-id="element-273" />
                  <span data-id="element-274">Verificado</span>
                </div>
              </div>
            </div>

            {/* Chat Messages */}
            <div className="space-y-3" data-id="element-275">
              {chat.messages.map((msg, msgIndex) => <motion.div key={msgIndex} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: chatIndex * 0.1 + msgIndex * 0.1
          }} viewport={{
            once: true
          }} className="flex items-end gap-2" data-id="element-276">
                  <div className="flex-1" data-id="element-277">
                    <div className={`inline-block max-w-[85%] bg-gradient-to-br ${chat.color} p-4 rounded-2xl rounded-bl-sm shadow-lg`} data-id="element-278">
                      <p className="text-white text-sm leading-relaxed" data-id="element-279">
                        {msg.text}
                      </p>
                    </div>
                    <p className="text-xs text-slate-500 mt-1 ml-2" data-id="element-280">
                      {msg.time}
                    </p>
                  </div>
                </motion.div>)}
            </div>

            {/* Typing indicator (last chat only) */}
            {chatIndex === chats.length - 1 && <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 1
        }} className="flex items-center gap-2 mt-4 text-slate-600 text-sm" data-id="element-281">
                <div className="flex gap-1" data-id="element-282">
                  <motion.div animate={{
              scale: [1, 1.2, 1]
            }} transition={{
              duration: 1,
              repeat: Infinity,
              delay: 0
            }} className="w-2 h-2 bg-slate-400 rounded-full" data-id="element-283" />
                  <motion.div animate={{
              scale: [1, 1.2, 1]
            }} transition={{
              duration: 1,
              repeat: Infinity,
              delay: 0.2
            }} className="w-2 h-2 bg-slate-400 rounded-full" data-id="element-284" />
                  <motion.div animate={{
              scale: [1, 1.2, 1]
            }} transition={{
              duration: 1,
              repeat: Infinity,
              delay: 0.4
            }} className="w-2 h-2 bg-slate-400 rounded-full" data-id="element-285" />
                </div>
                <span data-id="element-286">Más mujeres están escribiendo...</span>
              </motion.div>}
          </motion.div>)}
      </div>

      {/* CTA at bottom */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.5
    }} viewport={{
      once: true
    }} className="text-center mt-12" data-id="element-287">
        <p className="text-xl text-slate-700 mb-6" data-id="element-288">
          Unite a cientos de mujeres que ya recuperaron su energía
        </p>
        <a href="https://checkout.infinita-mente.online/checkouts/cn/hWN8DLQrMRMlUOLBbsQXm56g/es-ar?_r=AQABVUqWxWx-YYE6q4IcunY9hcWfSVp5nwYN6qJAahvLEQc&cart_link_id=qAwPfsYD&preview_theme_id=138558668898" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-gradient-to-r from-fuchsia-500 to-pink-500 text-white px-8 py-4 rounded-full font-bold hover:scale-105 transition-transform shadow-lg shadow-fuchsia-500/30" data-id="element-289">
          Quiero unirme a la comunidad
        </a>
      </motion.div>
    </Section>;
}